import React from 'react';

// Components Styled
import { Body, Container, Header, Button, CloseIconImg } from './styles';

// Types
import { ModalContainerProps } from './types';

// Components
import { Typography } from '../../../display/Typography';

export default function ModalContainer({
  children,
  onClickClose,
  title,
  width,
  modalType,
  hideClose = false,
}: ModalContainerProps): JSX.Element {
  return (
    <Container width={width} type={modalType}>
      <Header>
        {title && (
          <Typography size="L" variant="semiBold">
            {title}
          </Typography>
        )}
        {/* Los modales bloqueantes no pintan la X. Enseñar un botón de cerrar
            que el `SuperModal` ignora es peor que no tenerlo: el usuario lo
            pulsa, no pasa nada, y concluye que la app está colgada. */}
        {!hideClose && (
          <Button onClick={onClickClose}>
            <CloseIconImg />
          </Button>
        )}
      </Header>
      <Body>{children}</Body>
    </Container>
  );
}
